import React, {Component} from 'react'
import {Container, Row, Col, Card, CardBody, CardTitle, CardText, Button, Input} from 'reactstrap'
import Router from 'next/router'
import moment from 'moment'
import {Query, Mutation} from 'react-apollo'
import gql from 'graphql-tag'
import {ToastContainer, toast} from 'react-toastify'
import {withRouter} from 'react-router-dom'

import AddProject from "./AddProject";
import Timesheets from "./Timesheets";
import UnbillableTimesheet from "./UnbillableTimesheet";
import TimesheetSummary from './TimesheetSummary'
import WeekCommencingSwitcher from "./WeekCommencingSwitcher";
import AUSelectGenerator from '../auto_updaters/Select'
import * as permissions from '../../../lib/permissions'
import TimesheetFilters from "./TimesheetFilters";
import Loading from "../Loading";

const AUSelectUsers = AUSelectGenerator('filter_users', 'user_id first_name last_name', 'user_id', ['first_name', 'last_name'], [{
    key: 'active',
    value: 1
}])

const QUERY = gql`query user($user_id: Int!, $week_commencing: String){
	user(user_id: $user_id){
    user_id
    first_name
    last_name
    project_activities(week_commencing: $week_commencing){
      user_project_activity_id
      project_activity_type{
        project_activity_type_id
        description
      }
      project{
        project_id_prefix
        project_id
        name
      }
      timesheets{
        id
        __typename
        user_project_activity_id
        timesheet_date
        user_id
        minutes_worked
        hours_worked
      }
      user_schedule{
        id
        start_date
        end_date
      }
      project_activity_budget{
        id
        description
        parent{
          stage
          address{
            full_address
        	}
        }
        address{
          full_address
        }
        comments(user_id: $user_id){
          id
          project_activity_budget_id
          note
          created_at
          user_id
          public
          user{
            first_name
            last_name
          }
        }
      }
    }
    unbillable_timesheets(week_commencing: $week_commencing){
      id
      __typename
      unbillable_type_id
      timesheet_date
      user_id
      minutes_worked
      hours_worked
      
    }
  }
}`

const PROJECT_ACTIVITY_MUTATION = gql`mutation go(
  $project_id: String!, 
  $project_activity_type_id: Int!, 
  $project_activity_budget_id: Int!,
  $user_id: Int!, 
  $week_commencing: String!,
  $detail: String
){
  upsert_user_project_activities(data: 
    {
      project_id: $project_id, 
      project_activity_type_id: $project_activity_type_id,
      project_activity_budget_id: $project_activity_budget_id,
      user_id: $user_id,
      created_by_user_id: $user_id,
      week_commencing: $week_commencing,
      detail: $detail
    }
  ){
    user_project_activity_id
      project_activity_type{
        project_activity_type_id
        description
      }
      project{
        project_id_prefix
        project_id
        name
      }
      timesheets{
        id
        __typename
        user_project_activity_id
        timesheet_date
        user_id
        minutes_worked
        hours_worked
      }
      user_schedule{
        id
        start_date
        end_date
      }
      project_activity_budget{
        id
        description
        parent{
          stage
          address{
            full_address
        	}
        }
        address{
          full_address
        }
        comments(user_id: $user_id){
          id
          project_activity_budget_id
          note
          created_at
          user_id
          public
          user{
            first_name
            last_name
          }
        }
      }
  }
}`

const SUBSCRIPTION = gql`subscription userTimesheetUpserted($user_id: Int!, $week_commencing: String!){
	userTimesheetUpserted(user_id: $user_id){
    user_id
    first_name
    last_name
    project_activities(week_commencing: $week_commencing){
      user_project_activity_id
      project_activity_type{
        project_activity_type_id
        description
      }
      project{
        project_id_prefix
        project_id
        name
      }
      timesheets{
        user_project_activity_id
        timesheet_date
        user_id
        minutes_worked
        hours_worked
      }
      user_schedule{
        id
        start_date
        end_date
      }
      project_activity_budget{
        id
        description
        parent{
          stage
          address{
            full_address
        	}
        }
        stage
        address{
          full_address
        }
        comments(user_id: $user_id){
          id
          project_activity_budget_id
          note
          created_at
          user_id
          public
          user{
            first_name
            last_name
          }
        }
      }
    }
    unbillable_timesheets(week_commencing: $week_commencing){
      unbillable_type_id
      timesheet_date
      user_id
      minutes_worked
      hours_worked
      unbillable_type{
        description
      }
    }
  }
}`

const COMMENTS_SUBSCRIPTION = gql`subscription project_activity_budget_notesUpserted($user_id: Int!){
  project_activity_budget_notesUpserted(user_id: $user_id){
    id
    project_activity_budget_id
    note
    created_at
    user_id
    public
    user{
      first_name
      last_name
    }
  }
}`


class Timesheet extends Component {


    constructor(props) {
        super(props)

        const {user} = JSON.parse(sessionStorage.getItem('user'))

        console.log('USER', user)

        this.state = {...props, user_id: user.user_id, logged_in_user: user.user_id, active: '1', office_id: ''}
    }

    addProject = (go, data) => {

        const {weekCommencing} = this.getWeekCommencingSetup()

        const variables = {
            project_id: data.project_id,
            project_activity_type_id: data.activity_type_id,
            project_activity_budget_id: data.project_activity_budget_id,
            user_id: this.state.user_id,
            week_commencing: weekCommencing,
            detail: data.detail
        }
        go({variables})
            .then(console.log)
            .catch(e => toast.error(e.message, {autoClose: false}))
    }

    getSums = (activities) => {
        const timesheets = activities
            .reduce((carry, {timesheets}) => carry.concat(timesheets), [])
            .reduce((carry, timesheet) => {
                const date = moment(timesheet.timesheet_date).format('YYYY-MM-DD')
                carry[date] = carry[date] + parseFloat(timesheet.hours_worked || 0) || parseFloat(timesheet.hours_worked || 0)
                return carry
            }, {})
        return timesheets
    }

    getUnbillableSums = (timesheets) => {
        return timesheets
            .reduce((carry, timesheet) => {
                const date = moment(timesheet.timesheet_date).format('YYYY-MM-DD')
                carry[date] = carry[date] + parseFloat(timesheet.hours_worked || 0) || parseFloat(timesheet.hours_worked || 0)
                return carry
            }, {})
    }

    getGrandTotal = (timesheets, unbillable) => {
        return this.sumObjectsByKey(timesheets, unbillable)
    }

    sumObjectsByKey = (...objs) => {
        return objs.reduce((a, b) => {
            for (let k in b) {
                if (b.hasOwnProperty(k))
                    a[k] = (a[k] || 0) + b[k];
            }
            return a;
        }, {});
    }

    getWeekCommencingSetup = () => {

        const {week_commencing} = this.props.match.params

        const days = []
        const weekCommencing = (week_commencing) ? moment(week_commencing).startOf('week').format('YYYY-MM-DD') : moment().startOf('week').format('YYYY-MM-DD')
        for (var i = 0; i < 7; i++) {
            days.push(moment(weekCommencing).add(i, 'days').format('YYYY-MM-DD'))
        }

        return {
            weekCommencing,
            days,
            nextWeek: moment(weekCommencing).add(7, 'days').format('YYYY-MM-DD'),
            lastWeek: moment(weekCommencing).add(-7, 'days').format('YYYY-MM-DD')
        }


    }

    render() {

        const setup = this.getWeekCommencingSetup()

        return (
            <Query query={QUERY} variables={{
                user_id: this.state.user_id,
                week_commencing: setup.weekCommencing
            }} fetchPolicy="network-only">
                {({subscribeToMore, loading, data: {user}}) => {
                    if (!loading) {
                        console.log('QUERY', user)
                        const timesheetSummary = this.getSums(user.project_activities)
                        const unbillableSummary = this.getUnbillableSums(user.unbillable_timesheets)
                        const grandTotalSummary = this.getGrandTotal(timesheetSummary, unbillableSummary)
                        return (
                            <Container fluid className="mt-4">

                                <Row>
                                    <Col>
                                        <h1 className="pt-2 pb-2">{user.first_name} {user.last_name}</h1>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>

                                        {
                                            permissions.checkPermission(permissions.TIMESHEETS_CAN_VIEW_OTHER_STAFF_TIMESHEETS) &&
                                            <TimesheetFilters
                                                selectedUserId={this.state.user_id}
                                                active={this.state.active}
                                                officeId={this.state.office_id}
                                                onUserChange={(user_id) => this.setState({user_id})}
                                                onActiveChange={(active) => this.setState({active})}
                                                onOfficeChange={(office_id) => this.setState({office_id})}
                                            />
                                        }

                                        <WeekCommencingSwitcher
                                            nextWeek={setup.nextWeek}
                                            lastWeek={setup.lastWeek}
                                            weekCommencing={setup.weekCommencing}
                                            onLastWeek={(lastWeek) => {
                                                this.props.history.push(`/timesheet/${lastWeek}`)
                                            }}
                                            onWeekChange={(week) => {
                                                this.props.history.push(`/timesheet/${week}`)
                                            }}
                                            onNextWeek={(nextWeek) => {
                                                this.props.history.push(`/timesheet/${nextWeek}`)
                                            }}
                                        />

                                        <Row>
                                            <Col className="col-2"/>
                                            {setup.days.map((day, index) => (
                                                <Col style={{
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    flex: 1,
                                                    display: 'flex',
                                                    paddingLeft: '5px',
                                                    paddingRight: '5px',
                                                }} key={index}>{moment(day).format('ddd Do')}</Col>
                                            ))}
                                        </Row>

                                        <div>

                                            <Timesheets
                                                activities={user.project_activities}
                                                days={setup.days}
                                                user_id={this.state.user_id}
                                                logged_in_user_id={this.state.logged_in_user_id}
                                                week_commencing={setup.weekCommencing}
                                                subscribeToComments={() => subscribeToMore({
                                                    document: COMMENTS_SUBSCRIPTION,
                                                    variables: {user_id: this.state.user_id},
                                                    updateQuery: (prev, {subscriptionData}) => {
                                                        console.log(prev)
                                                        console.log(subscriptionData)
                                                        if (!subscriptionData.data || !subscriptionData.data.project_activity_budget_notesUpserted) return prev;


                                                        const {user} = prev
                                                        const {project_activity_budget_notesUpserted} = subscriptionData.data

                                                        if (this.state.user_id == project_activity_budget_notesUpserted.user_id ||
                                                            project_activity_budget_notesUpserted.public) {

                                                            console.log('SUBSCRIPTION', project_activity_budget_notesUpserted)

                                                            const newProjectActivities = user.project_activities.reduce((carry, pa) => {
                                                                let newPa = JSON.parse(JSON.stringify(pa))

                                                                if (pa.project_activity_budget.id === project_activity_budget_notesUpserted.project_activity_budget_id &&
                                                                    !pa.project_activity_budget.comments.some(comment => comment.id == project_activity_budget_notesUpserted.id)) {
                                                                    const newComments = [
                                                                        ...pa.project_activity_budget.comments,
                                                                        {...project_activity_budget_notesUpserted}
                                                                    ]
                                                                    newPa.project_activity_budget.comments = newComments
                                                                }
                                                                carry.push(newPa)
                                                                return carry
                                                            }, [])

                                                            const newUser = {
                                                                ...user,
                                                                project_activities: newProjectActivities
                                                            }

                                                            return {user: newUser}
                                                        }

                                                        return prev

                                                    }
                                                })

                                                }
                                            />
                                            <TimesheetSummary days={setup.days} label="Total"
                                                              values={timesheetSummary}/>

                                            <Mutation
                                                mutation={PROJECT_ACTIVITY_MUTATION}
                                                update={(cache, {data: {upsert_user_project_activities}}) => {
                                                    const {user} = cache.readQuery({
                                                        query: QUERY,
                                                        variables: {
                                                            user_id: this.state.user_id,
                                                            week_commencing: setup.weekCommencing
                                                        }
                                                    });

                                                    const newUser = {
                                                        ...user,
                                                        project_activities: [...user.project_activities, {...upsert_user_project_activities}]
                                                    }

                                                    cache.writeQuery({
                                                        query: QUERY,
                                                        data: {user: newUser},
                                                        variables: {
                                                            user_id: this.state.user_id,
                                                            week_commencing: setup.weekCommencing
                                                        }
                                                    });
                                                }}
                                            >
                                                {(go) => (
                                                    <Row style={{
                                                        paddingTop: '20px',
                                                        paddingBottom: '20px',
                                                        backgroundColor: 'lightgray',
                                                        marginTop: '20px',
                                                        marginBottom: '20px'
                                                    }}>
                                                        <Col><AddProject
                                                            onAdd={(data) => this.addProject(go, data)}/></Col>
                                                    </Row>
                                                )
                                                }
                                            </Mutation>
                                            <h5>Unbillable</h5>
                                            <UnbillableTimesheet
                                                days={setup.days}
                                                timesheets={user.unbillable_timesheets}
                                                week_commencing={setup.weekCommencing}
                                                user_id={this.state.user_id}
                                            />
                                            <TimesheetSummary days={setup.days} label="Total"
                                                              values={unbillableSummary}/>
                                            <TimesheetSummary days={setup.days} label="Grand Total"
                                                              values={grandTotalSummary}/>

                                        </div>


                                    </Col>
                                </Row>
                                <ToastContainer/>
                            </Container>)
                    }
                    return <Loading/>
                }}

            </Query>

        )
    }
}

Timesheet = withRouter(Timesheet)

export default Timesheet